import { createUseStyles } from 'react-jss';

const iconSize = new Map([
  ['xsmall', 24],
  ['small', 32],
  ['medium', 40],
  ['large', 64],
]);

export const useStyles = createUseStyles<
  string,
  {
    backgroundColor: string;
    size: 'xsmall' | 'small' | 'large' | 'medium';
    iconWidth: number;
    iconHeight: number;
    iconColor: string;
    isRound?: boolean;
  }
>({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: ({ isRound }) => (isRound ? '50%' : '8px'),
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    width: ({ size }) => iconSize.get(size),
    height: ({ size }) => iconSize.get(size),

    '& svg': {
      width: ({ iconWidth }) => iconWidth,
      height: ({ iconHeight }) => iconHeight,

      '& path': {
        fill: ({ iconColor }) => iconColor,
      },
    },
  },
});

export default useStyles;
